import { State, Action, SaveStatus } from "./custom-vocabulary-settings.types";

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case "SET_VALUE":
      return {
        ...state,
        currentValue: action.value,
        error: action.error,
        saveStatus: state.saveStatus === SaveStatus.Saved ? SaveStatus.Idle : state.saveStatus,
      };
    case "START_SAVING":
      return { ...state, saveStatus: SaveStatus.Saving };
    case "SAVE_SUCCESS":
      return {
        ...state,
        currentValue: action.value,
        originalValue: action.value,
        saveStatus: SaveStatus.Saved,
      };
    case "SAVE_ERROR":
      return { ...state, error: action.error, saveStatus: SaveStatus.Idle };
    case "CANCEL":
      return {
        ...state,
        currentValue: state.originalValue,
        error: null,
        saveStatus: SaveStatus.Idle,
      };
    default:
      return state;
  }
}
